angular.module('iqxCore').service('BehaviourSvc', function (ApplicationSvc, ApiSvc, $cookies) {
  var svc = this
  var fetchScope = {}
  svc.behaviour = {}

  svc.get = function (divisionID) {
    divisionID = divisionID || false
    return ApiSvc.fetch(fetchScope, {
      fetchAPI: 'callresult' + (ApplicationSvc.isLoggedIn ? '' : '_') + '/NetBehaviour' + _divID(divisionID),
      fetchTarget: 'behaviour',
      multiRow: true,
      booleanFields: [],
      notLoggedIn: true // http default headers set but applicationSvc isLoggedIn still false, so need this but procedure still authenticated (dont add to unauthenticated list).
    })
      .then(function () {
        _setTypes(fetchScope.behaviour)
      })
      .then(function () {
        $cookies.putObject('IQXBehaviour', svc.behaviour)
      })
  }

  svc.isSwitchedOn = function (x) {
    return ApplicationSvc.params.behaviour[x]
  }

  svc.timesheetSigningSettings = function () {
    return {
      addShifts: ApplicationSvc.params.behaviour.TSSADDSHIFTS,
      editShiftDescription: ApplicationSvc.params.behaviour.TSSEDITSHIFTDESCRIPTION,
      editShiftBreak: ApplicationSvc.params.behaviour.TSSEDITSHIFTBREAK,
      moveShifts: ApplicationSvc.params.behaviour.TSSMOVESHIFT,
      showRates: ApplicationSvc.params.behaviour.TSSSHOWRATES,
      clientShowRates: ApplicationSvc.params.behaviour.TSSCLIENTSHOWRATES,
      showExpenses: ApplicationSvc.params.behaviour.TSSSHOWEXPENSES,
      showExpensesClient: ApplicationSvc.params.behaviour.TSSSHOWEXPENSESCLIENT,
      allowSignOnDevice: ApplicationSvc.params.behaviour.TSSALLOWSIGNONDEVICE,
      allowSignViaSendLink: ApplicationSvc.params.behaviour.TSSALLOWSIGNVIALINK,
      allowUploadingTimesheetImage: ApplicationSvc.params.behaviour.TSSALLOWUPLOADINGTIMESHEETIMAG,
      numberOfWeeksToCheckForTimesheets: ApplicationSvc.params.behaviour.TSSNUMOFWEEKSCHECKFORTIMESHEET,
      captureGEOLocation: ApplicationSvc.params.behaviour.TSSCAPTUREGEOLOCATION,
      hidePrint: ApplicationSvc.params.behaviour.TSSHIDEPRINT,
      clientHidePrint: ApplicationSvc.params.behaviour.TSSCLIENTHIDEPRINT,
      canCopyShift: ApplicationSvc.params.behaviour.TSSCOPYSHIFT,
      canDuplicateShift: ApplicationSvc.params.behaviour.TSSDUPLICATESHIFT,
      clientDepartmentalQuestions: ApplicationSvc.params.behaviour.TSSCLIENTDEPTQUEST,
      hoursLeeway: ApplicationSvc.params.behaviour.TSSHOURSLEEWAY,
      showTotalHoursCalc: ApplicationSvc.params.behaviour.TSSTOTALHOURSCALC,
      showPaymentType: ApplicationSvc.params.behaviour.TSSSHOWPAYTYPE,
      signTimestampDateOnly: ApplicationSvc.params.behaviour.TSSSIGNDATEONLY,
      candidateConfirmTimesheetSign: ApplicationSvc.params.behaviour.TSSCONFIRMSIGN,
      canEditShiftDate: ApplicationSvc.params.behaviour.TSSEDITSHIFTDATE,
      useNewShiftTemplate: ApplicationSvc.params.behaviour.TSSNEWSHIFTTEMPLATE,
      newShiftStart: ApplicationSvc.params.behaviour.TSSSHIFTSTART,
      newShiftEnd: ApplicationSvc.params.behaviour.TSSSHIFTEND,
      newShiftBreak: ApplicationSvc.params.behaviour.TSSSHIFTBREAK,
      showNeedsSignature: ApplicationSvc.params.behaviour.TSSNEEDSSIGNATURE,
      showEdit: ApplicationSvc.params.behaviour.TSSSHOWEDIT,
      showPosition: ApplicationSvc.params.behaviour.TSSSHOWPOSITION,
      alwaysSendTimesheetSummary: ApplicationSvc.params.behaviour.TSSALWAYSSENDSUMMARY,
      showWarningIfMoreThan1Shift: ApplicationSvc.params.behaviour.TSSWARNINGMORETHAN1SHIFT,
      signEachLine: ApplicationSvc.params.behaviour.TSSSIGNEACHLINE,
      allowDeleteShift: ApplicationSvc.params.behaviour.TSSDELETESHIFT,
      allowUntickCalc: ApplicationSvc.params.behaviour.TSSUNTICKCALC,
      useWeekStartDateOnTS: ApplicationSvc.params.behaviour.TSSWEEKSTART,
      useShiftTypes: ApplicationSvc.params.behaviour.TSSSHIFTTYPES,
      logo: ApplicationSvc.params.behaviour.TSSLOGOFILE,
      pdftemplate: ApplicationSvc.params.behaviour.TSSPDFTEMPLATE,
      clientSignMulti: ApplicationSvc.params.behaviour.TSSCLIENTSIGNMULTI,
      signEachBreak: ApplicationSvc.params.behaviour.TSSSHOWSIGONBREAK
    }
  }

  function _divID(divisionID) {
    if (divisionID) {
      return '?pDivisionID=' + divisionID
    }
    if (ApplicationSvc.currentUser.registrationDetails) {
      // Candidate
      return '?pDivisionID=' + ApplicationSvc.currentUser.registrationDetails.DivisionID
    } else if (ApplicationSvc.currentUser.divisionid) {
      // client
      return '?pDivisionID=' + ApplicationSvc.currentUser.divisionid
    } else {
      // everyone else?
      return ''
    }
  }

  function _setTypes(behaviourObject) {
    behaviourObject.forEach((b) => {
      switch (b.DataType) {
        case 'B': // boolean
          svc.behaviour[b.BehaviourID] = b.Value === '0' ? false : true
          break

        case 'S': // string
        default: // catch all
          svc.behaviour[b.BehaviourID] = b.Value
          break

        case 'N': // number
          svc.behaviour[b.BehaviourID] = parseInt(b.Value)
          break
      }
    })
  }
})
